import { ArbitrumSepolia, BaseSepolia, BlastSepolia, DODOChainTestnet, DuckchainTestnet, EthereumSepolia, KakarotSepolia, Linea, LineaSepolia, Merlin, OptimismSepolia, TaikoHekla, ZircuitTestnet, } from '@particle-network/chains';
import { SUPPORTED_TOKEN_TYPE } from './types';
import { getNewEVMChainInfoById } from './utils';
export { LAMPORTS_PER_SOL } from '@solana/web3.js';
export const WSOL_TOKEN_ADDRESS = 'So11111111111111111111111111111111111111112';
export const EVM_SWAP_NATIVE_ADDDRESS = `0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee`;
export const EVM_DEFAULT_ADDRESS = '0x0000000000000000000000000000000000000000';
export const ZeroAddress = '0x0000000000000000000000000000000000000000';
export const SolanaNetworkFee = 0.000005;
const production = process.env.NODE_ENV === 'production';
export const STATIC_PARTICLE_NETWORK = production ? 'https://static.particle.network' : '';
export const ValidEvmAddress = /^0x[a-fA-F0-9]{40}$/;
export const DateFormat = 'DD/MM/YYYY HH:mm:ss';
export const SWAP_CHAIN_LIST = [
    {
        chainId: 101,
        chainName: 'SOLANA',
    },
    {
        chainId: 1,
        chainName: 'ETHEREUM',
    },
    {
        chainId: 56,
        chainName: 'bsc',
    },
    {
        chainId: 137,
        chainName: 'POLYGON',
    },
    {
        chainId: 43114,
        chainName: 'AVALANCHE',
    },
    {
        chainId: 250,
        chainName: 'FANTOM',
    },
    {
        chainId: 42161,
        chainName: 'ARBITRUM',
    },
    {
        chainId: 10,
        chainName: 'OPTIMISM',
    },
    {
        chainId: 8217,
        chainName: 'KLAYTN',
    },
    {
        chainId: 100,
        chainName: 'GNOSIS',
    },
    {
        chainId: 1313161554,
        chainName: 'AURORA',
    },
    {
        chainId: 324,
        chainName: 'zkSync',
    },
    {
        chainId: 66,
        chainName: 'OKC',
    },
    {
        chainId: 1284,
        chainName: 'Moonbeam',
    },
    {
        chainId: 1285,
        chainName: 'Moonriver',
    },
    {
        chainId: 42220,
        chainName: 'Celo',
    },
    {
        chainId: 25,
        chainName: 'Cronos',
    },
    {
        chainId: 5000,
        chainName: 'Mantle',
    },
    {
        chainId: 8453,
        chainName: 'Base',
    },
    {
        chainId: 1101,
        chainName: 'PolygonZkEVM',
    },
    {
        chainId: 169,
        chainName: 'Manta',
    },
    {
        chainId: 534352,
        chainName: 'Scroll',
    },
    {
        chainId: 42766,
        chainName: 'ZKFair',
    },
    {
        chainId: Linea.id,
        chainName: Linea.name,
    },
    {
        chainId: Merlin.id,
        chainName: Merlin.name,
    },
];
export const UniversalApiUrl = process.env.NEXT_PUBLIC_UNIVERSAL_API_URL;
export const PioneerChainId = Number(process.env.NEXT_PUBLIC_PIONEER_CHAIN_ID);
export const UniversalMultiChainModuleAddress = process.env.NEXT_PUBLIC_UNIVERSAL_MULTI_CHAIN_MODULE_ADDRESS;
export const particleChain = {
    id: 2011,
    name: 'Particle',
    chainType: 'evm',
    icon: 'https://wallet-debug.particle.network/wallet-icon3.png',
    nativeIcon: 'https://wallet-debug.particle.network/ug.png',
    fullname: 'Particle Testnet',
    network: 'Testnet',
    website: 'https://particle.network',
    nativeCurrency: {
        name: 'USDG',
        symbol: 'USDG',
        decimals: 18,
    },
    rpcUrl: 'https://chain-testnet-public.particle.network',
    blockExplorerUrl: 'https://scan-testnet.particle.network',
    features: [
        {
            name: 'EIP1559',
        },
    ],
};
export const particleChainV2 = {
    id: 2012,
    name: 'Particle',
    chainType: 'evm',
    icon: 'https://wallet.particle.network/wallet-icon3.png',
    nativeIcon: 'https://wallet.particle.network/ug.png',
    fullname: 'Particle Testnet',
    network: 'Testnet',
    website: 'https://particle.network',
    nativeCurrency: {
        name: 'USDG',
        symbol: 'USDG',
        decimals: 18,
    },
    rpcUrl: 'https://chain-testnet-public.particle.network',
    blockExplorerUrl: 'https://scan-testnet-v2.particle.network',
    features: [
        {
            name: 'EIP1559',
        },
    ],
};
export const getGlobalChain = (name = 'All Networks') => {
    return {
        chainName: name,
        chainNetwork: 'Testnet',
        symbol: 'UA',
        fullname: name,
        evm1559support: false,
        chainType: 'evm',
        chainId: 999000000000999,
        scanUrl: '',
        txUrl: '',
        icon: '/images/ua/chain.png',
        nativeIcon: '/images/ua/native.png',
        selected: false,
        decimals: 18,
        chainData: {
            '999000000000999': {
                id: 999000000000999,
                name: name,
                chainType: 'evm',
                icon: '/images/ua/chain.png',
                nativeIcon: '/images/ua/native.png',
                fullname: name,
                network: 'Testnet',
                nativeCurrency: {
                    name: 'ua',
                    symbol: 'ua',
                    decimals: 18,
                },
                rpcUrl: '',
                faucetUrl: '',
                blockExplorerUrl: '',
            },
        },
    };
};
const EVM_CHAIN_ID = {
    ETHEREUM_SEPOLIA: EthereumSepolia.id,
    OPTIMISM_TESTNET_SEPOLIA: OptimismSepolia.id,
    ARBITRUM_TESTNET_SEPOLIA: ArbitrumSepolia.id,
    BASE_TESTNET_SEPOLIA: BaseSepolia.id,
    DUCKCHAIN_TESTNET: DuckchainTestnet.id,
    DODOCHAIN_TESTNET: DODOChainTestnet.id,
    // LINEA_TESTNET_SEPOLIA: LineaSepolia.id,
    // BLAST_TESTNET_SEPOLIA: BlastSepolia.id,
    // PARTICLE_PANGU_TESTNET: particleChain.id,
    // BSC_TESTNET: BNBChainTestnet.id,
    // COMBO_TESTNET_V2: ComboTestnet.id,
    // XTERIO_TESTNET: XterioBNBTestnet.id,
    // OPBNB_TESTNET: opBNBTestnet.id,
    // MERLIN_TESTNET: MerlinTestnet.id,
    // BSQUARED_TESTNET: BSquaredTestnet.id,
    // BITLAYER_TESTNET: BitlayerTestnet.id,
    // SEI_TESTNET: SeiTestnet.id,
    // BERACHAIN_TESTNET_BARTIO: BerachainbArtio.id,
    // TAIKO_TESTNET_HEKLA: TaikoHekla.id,
    // KAKAROT_TESTNET: KakarotSepolia.id,
    // ZIRCUIT_TESTNET: ZircuitTestnet.id,
    // PolygonAmoy: PolygonAmoy.id,
    // AvalancheTestnet: AvalancheTestnet.id,
    // BSquaredTestnet: BSquaredTestnet.id
};
/**
 * chainList 顺序
 */
export const uaChainOrder = [EthereumSepolia.id, OptimismSepolia.id, ArbitrumSepolia.id, BaseSepolia.id, LineaSepolia.id, BlastSepolia.id, particleChain.id];
/**
 * https://minijoy.feishu.cn/docx/MkdTdRqBwo7ds2xKD4UcTDsInWh#PA09df7H8oZGYyxP0BbcIPaZnch
 */
export const SUPPORTED_TARGET_TOKENS = [
    {
        type: SUPPORTED_TOKEN_TYPE.ETH,
        chainId: EVM_CHAIN_ID.ETHEREUM_SEPOLIA,
        tokenAddress: ZeroAddress,
        decimals: 18,
        exchangeRateToUSD: 3600, // fake exchange rate at testnet
    },
    {
        type: SUPPORTED_TOKEN_TYPE.ETH,
        chainId: EVM_CHAIN_ID.OPTIMISM_TESTNET_SEPOLIA,
        tokenAddress: ZeroAddress,
        decimals: 18,
        exchangeRateToUSD: 3600,
    },
    {
        type: SUPPORTED_TOKEN_TYPE.ETH,
        chainId: EVM_CHAIN_ID.ARBITRUM_TESTNET_SEPOLIA,
        tokenAddress: ZeroAddress,
        decimals: 18,
        exchangeRateToUSD: 3600,
    },
    {
        type: SUPPORTED_TOKEN_TYPE.ETH,
        chainId: EVM_CHAIN_ID.BASE_TESTNET_SEPOLIA,
        tokenAddress: ZeroAddress,
        decimals: 18,
        exchangeRateToUSD: 3600,
    },
    // {
    //   type: SUPPORTED_TOKEN_TYPE.ETH,
    //   chainId: EVM_CHAIN_ID.TAIKO_TESTNET_HEKLA,
    //   tokenAddress: ZeroAddress,
    //   decimals: 18,
    //   exchangeRateToUSD: 3600,
    // },
    // {
    //   type: SUPPORTED_TOKEN_TYPE.ETH,
    //   chainId: EVM_CHAIN_ID.KAKAROT_TESTNET,
    //   tokenAddress: ZeroAddress,
    //   decimals: 18,
    //   exchangeRateToUSD: 3600,
    // },
    // {
    //   type: SUPPORTED_TOKEN_TYPE.ETH,
    //   chainId: EVM_CHAIN_ID.ZIRCUIT_TESTNET,
    //   tokenAddress: ZeroAddress,
    //   decimals: 18,
    //   exchangeRateToUSD: 3600,
    // },
    // {
    //   type: SUPPORTED_TOKEN_TYPE.ETH,
    //   chainId: EVM_CHAIN_ID.BLAST_TESTNET_SEPOLIA,
    //   tokenAddress: ZeroAddress,
    //   decimals: 18,
    //   exchangeRateToUSD: 3600,
    // },
    // {
    //   type: SUPPORTED_TOKEN_TYPE.ETH,
    //   chainId: EVM_CHAIN_ID.LINEA_TESTNET_SEPOLIA,
    //   tokenAddress: ZeroAddress,
    //   decimals: 18,
    //   exchangeRateToUSD: 3600,
    // },
    // USDC
    {
        type: SUPPORTED_TOKEN_TYPE.USDC,
        chainId: EVM_CHAIN_ID.ETHEREUM_SEPOLIA,
        tokenAddress: '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238',
        decimals: 6,
        exchangeRateToUSD: 1,
        slotIndex: 9,
    },
    {
        type: SUPPORTED_TOKEN_TYPE.USDC,
        chainId: EVM_CHAIN_ID.OPTIMISM_TESTNET_SEPOLIA,
        tokenAddress: '0x5fd84259d66Cd46123540766Be93DFE6D43130D7',
        decimals: 6,
        exchangeRateToUSD: 1,
        slotIndex: 9,
    },
    {
        type: SUPPORTED_TOKEN_TYPE.USDC,
        chainId: EVM_CHAIN_ID.ARBITRUM_TESTNET_SEPOLIA,
        tokenAddress: '0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d',
        decimals: 6,
        exchangeRateToUSD: 1,
        slotIndex: 9,
    },
    {
        type: SUPPORTED_TOKEN_TYPE.USDC,
        chainId: EVM_CHAIN_ID.BASE_TESTNET_SEPOLIA,
        tokenAddress: '0x036CbD53842c5426634e7929541eC2318f3dCF7e',
        decimals: 6,
        exchangeRateToUSD: 1,
        slotIndex: 9,
    },
    {
        type: SUPPORTED_TOKEN_TYPE.USDT,
        chainId: EVM_CHAIN_ID.OPTIMISM_TESTNET_SEPOLIA,
        tokenAddress: '0x4bA3A5ab2EC0C9C45F153374fbcb05a1526C4a01',
        decimals: 6,
        exchangeRateToUSD: 1,
        slotIndex: 0,
    },
    // USDG
    // {
    //   type: SUPPORTED_TOKEN_TYPE.USDG,
    //   chainId: EVM_CHAIN_ID.PARTICLE_PANGU_TESTNET_V2,
    //   tokenAddress: ZeroAddress,
    //   decimals: 18,
    //   exchangeRateToUSD: 1,
    // },
    // {
    //   type: SUPPORTED_TOKEN_TYPE.USDG,
    //   chainId: EVM_CHAIN_ID.PARTICLE_PANGU_TESTNET,
    //   tokenAddress: ZeroAddress,
    //   decimals: 18,
    //   exchangeRateToUSD: 1,
    // },
    {
        type: SUPPORTED_TOKEN_TYPE.USDG,
        chainId: EVM_CHAIN_ID.ETHEREUM_SEPOLIA,
        tokenAddress: '0xbfDB9AD842899D2F51928dCBA316E176d314f0b9',
        decimals: 18,
        exchangeRateToUSD: 1,
        slotIndex: 0,
    },
    {
        type: SUPPORTED_TOKEN_TYPE.USDG,
        chainId: EVM_CHAIN_ID.OPTIMISM_TESTNET_SEPOLIA,
        tokenAddress: '0xB86b3C01a55824977Bd4F6097F2b85D2175C90b8',
        decimals: 18,
        exchangeRateToUSD: 1,
        slotIndex: 0,
    },
    {
        type: SUPPORTED_TOKEN_TYPE.USDG,
        chainId: EVM_CHAIN_ID.ARBITRUM_TESTNET_SEPOLIA,
        tokenAddress: '0xB8981C1E85f5Acfbf1760Cb4DB3933526d8a269e',
        decimals: 18,
        exchangeRateToUSD: 1,
        slotIndex: 0,
    },
    {
        type: SUPPORTED_TOKEN_TYPE.USDG,
        chainId: EVM_CHAIN_ID.BASE_TESTNET_SEPOLIA,
        tokenAddress: '0xD4fA4dE9D8F8DB39EAf4de9A19bF6910F6B5bD60',
        decimals: 18,
        exchangeRateToUSD: 1,
        slotIndex: 0,
    },
    // {
    //   type: SUPPORTED_TOKEN_TYPE.USDG,
    //   chainId: EVM_CHAIN_ID.TAIKO_TESTNET_HEKLA,
    //   tokenAddress: '0xbEAB55dec33d6B43c90dFb1127b73304bA9c3a9B',
    //   decimals: 18,
    //   exchangeRateToUSD: 1,
    //   slotIndex: 0,
    // },
    // {
    //   type: SUPPORTED_TOKEN_TYPE.USDG,
    //   chainId: EVM_CHAIN_ID.KAKAROT_TESTNET,
    //   tokenAddress: '0x83E15FDaeD52DD06725eFbF08D40EaFF6dD043D4',
    //   decimals: 18,
    //   exchangeRateToUSD: 1,
    //   slotIndex: 0,
    // },
    // {
    //   type: SUPPORTED_TOKEN_TYPE.USDG,
    //   chainId: EVM_CHAIN_ID.ZIRCUIT_TESTNET,
    //   tokenAddress: '0x83E15FDaeD52DD06725eFbF08D40EaFF6dD043D4',
    //   decimals: 18,
    //   exchangeRateToUSD: 1,
    //   slotIndex: 0,
    // },
    // {
    //   type: SUPPORTED_TOKEN_TYPE.USDG,
    //   chainId: EVM_CHAIN_ID.BLAST_TESTNET_SEPOLIA,
    //   tokenAddress: '0x4649d171c67658C57D40618Cfc16b2A7866E48A3',
    //   decimals: 18,
    //   exchangeRateToUSD: 1,
    //   slotIndex: 0,
    // },
    // {
    //   type: SUPPORTED_TOKEN_TYPE.USDG,
    //   chainId: EVM_CHAIN_ID.LINEA_TESTNET_SEPOLIA,
    //   tokenAddress: '0x555E50D961b770B9cBc934f944E3Edc2d003e26f',
    //   decimals: 18,
    //   exchangeRateToUSD: 1,
    //   slotIndex: 0,
    // },
    // {
    //   type: SUPPORTED_TOKEN_TYPE.USDG,
    //   chainId: EVM_CHAIN_ID.SEI_TESTNET,
    //   tokenAddress: '0xe5c3ac206DaDAf03c10E4246ecec8836070d59B2',
    //   decimals: 18,
    //   exchangeRateToUSD: 1,
    //   slotIndex: 0,
    // },
    // {
    //   type: SUPPORTED_TOKEN_TYPE.USDG,
    //   chainId: EVM_CHAIN_ID.BERACHAIN_TESTNET_BARTIO,
    //   tokenAddress: '0x83E15FDaeD52DD06725eFbF08D40EaFF6dD043D4',
    //   decimals: 18,
    //   exchangeRateToUSD: 1,
    //   slotIndex: 0,
    // },
    // {
    //     type: SUPPORTED_TOKEN_TYPE.USDG,
    //     chainId: EVM_CHAIN_ID.BSC_TESTNET,
    //     tokenAddress: '0x77a40e82A447EB5FC029a3577C86B8889c1EdA49',
    //     decimals: 18,
    //     exchangeRateToUSD: 1,
    //     slotIndex: 0,
    // },
    // {
    //     type: SUPPORTED_TOKEN_TYPE.USDG,
    //     chainId: EVM_CHAIN_ID.OPBNB_TESTNET,
    //     tokenAddress: '0xeF1af9305e1d0A44683d126AFefaCc6929318D3c',
    //     decimals: 18,
    //     exchangeRateToUSD: 1,
    //     slotIndex: 0,
    // },
    // {
    //     type: SUPPORTED_TOKEN_TYPE.USDG,
    //     chainId: EVM_CHAIN_ID.COMBO_TESTNET_V2,
    //     tokenAddress: '0x9B7D9636Af8dDe6dC18DCFa8D699e99cB7873Aca',
    //     decimals: 18,
    //     exchangeRateToUSD: 1,
    //     slotIndex: 0,
    // },
    // {
    //     type: SUPPORTED_TOKEN_TYPE.USDG,
    //     chainId: EVM_CHAIN_ID.XTERIO_TESTNET,
    //     tokenAddress: '0x5242B24Cd0E03b316cD815576E9dD72c10482563',
    //     decimals: 18,
    //     exchangeRateToUSD: 1,
    //     slotIndex: 0,
    // },
    // {
    //     type: SUPPORTED_TOKEN_TYPE.USDG,
    //     chainId: EVM_CHAIN_ID.MERLIN_TESTNET,
    //     tokenAddress: '0x56b1B1f73bBa1A8d7651972dA2c1fba2ACDe93FB',
    //     decimals: 18,
    //     exchangeRateToUSD: 1,
    //     slotIndex: 0,
    // },
    // {
    //     type: SUPPORTED_TOKEN_TYPE.USDG,
    //     chainId: EVM_CHAIN_ID.BSQUARED_TESTNET,
    //     tokenAddress: '0x58B035064A2eE76Cf438d45A2bf5f7208aA0329F',
    //     decimals: 18,
    //     exchangeRateToUSD: 1,
    //     slotIndex: 0,
    // },
    // {
    //     type: SUPPORTED_TOKEN_TYPE.USDG,
    //     chainId: EVM_CHAIN_ID.BITLAYER_TESTNET,
    //     tokenAddress: '0x0923a66C3DD657614B079F607d977dbc0ECBa813',
    //     decimals: 18,
    //     exchangeRateToUSD: 1,
    //     slotIndex: 0,
    // },
    // {
    //     type: SUPPORTED_TOKEN_TYPE.BNB,
    //     chainId: EVM_CHAIN_ID.BSC_TESTNET,
    //     tokenAddress: ZeroAddress,
    //     decimals: 18,
    //     exchangeRateToUSD: 600,
    // },
    // {
    //     type: SUPPORTED_TOKEN_TYPE.BNB,
    //     chainId: EVM_CHAIN_ID.OPBNB_TESTNET,
    //     tokenAddress: ZeroAddress,
    //     decimals: 18,
    //     exchangeRateToUSD: 600,
    // },
    // {
    //     type: SUPPORTED_TOKEN_TYPE.BNB,
    //     chainId: EVM_CHAIN_ID.COMBO_TESTNET_V2,
    //     tokenAddress: ZeroAddress,
    //     decimals: 18,
    //     exchangeRateToUSD: 600,
    // },
    // {
    //     type: SUPPORTED_TOKEN_TYPE.BNB,
    //     chainId: EVM_CHAIN_ID.XTERIO_TESTNET,
    //     tokenAddress: ZeroAddress,
    //     decimals: 18,
    //     exchangeRateToUSD: 600,
    // },
    // {
    //     type: SUPPORTED_TOKEN_TYPE.BTC,
    //     chainId: EVM_CHAIN_ID.MERLIN_TESTNET,
    //     tokenAddress: ZeroAddress,
    //     decimals: 18,
    //     exchangeRateToUSD: 63000,
    // },
    // {
    //     type: SUPPORTED_TOKEN_TYPE.BTC,
    //     chainId: EVM_CHAIN_ID.BSQUARED_TESTNET,
    //     tokenAddress: ZeroAddress,
    //     decimals: 18,
    //     exchangeRateToUSD: 63000,
    // },
    // {
    //     type: SUPPORTED_TOKEN_TYPE.BTC,
    //     chainId: EVM_CHAIN_ID.BITLAYER_TESTNET,
    //     tokenAddress: ZeroAddress,
    //     decimals: 18,
    //     exchangeRateToUSD: 63000,
    // },
    {
        type: SUPPORTED_TOKEN_TYPE.USDG,
        chainId: EVM_CHAIN_ID.DODOCHAIN_TESTNET,
        tokenAddress: '0x83E15FDaeD52DD06725eFbF08D40EaFF6dD043D4',
        decimals: 18,
        exchangeRateToUSD: 1,
        slotIndex: 0,
    },
    {
        type: SUPPORTED_TOKEN_TYPE.USDG,
        chainId: EVM_CHAIN_ID.DUCKCHAIN_TESTNET,
        tokenAddress: '0x83E15FDaeD52DD06725eFbF08D40EaFF6dD043D4',
        decimals: 18,
        exchangeRateToUSD: 1,
        slotIndex: 0,
    },
];
export const getSupportedTARGETToken = () => {
    return SUPPORTED_TARGET_TOKENS.map((token) => {
        return {
            ...token,
            ...getNewEVMChainInfoById(token.chainId),
        };
    });
};
/**
 * https://minijoy.feishu.cn/docx/MkdTdRqBwo7ds2xKD4UcTDsInWh#RVRxdJwD6oZK2Hx2qi1caPqtn3e
 */
export const BLOCK_TIME = {
    2011: 2,
    11155111: 12,
    11155420: 2,
    84532: 2,
    421614: 1,
    168587773: 2,
    59141: 2,
    80002: 2,
    97: 3,
    5611: 1,
    1715: 1,
    1637450: 1,
    43113: 1,
    686868: 2,
    1123: 2,
    200810: 3,
    80084: 1,
    1328: 1,
    167009: 5,
    1802203764: 5,
    48899: 5,
    [DODOChainTestnet.id]: 1,
    [DuckchainTestnet.id]: 1,
};
/**
 * https://minijoy.feishu.cn/docx/MkdTdRqBwo7ds2xKD4UcTDsInWh#SWQqdJ8g3oFnmKxDLMBczPiXnKd
 */
export const LP_SUPPORTED_CHAINS = [
    EVM_CHAIN_ID.OPTIMISM_TESTNET_SEPOLIA,
    EVM_CHAIN_ID.BASE_TESTNET_SEPOLIA,
    // EVM_CHAIN_ID.PARTICLE_PANGU_TESTNET,
    EVM_CHAIN_ID.ARBITRUM_TESTNET_SEPOLIA,
    // EVM_CHAIN_ID.BLAST_TESTNET_SEPOLIA,
    // EVM_CHAIN_ID.LINEA_TESTNET_SEPOLIA,
    EVM_CHAIN_ID.ETHEREUM_SEPOLIA,
    // EVM_CHAIN_ID.TAIKO_TESTNET_HEKLA,
    // EVM_CHAIN_ID.KAKAROT_TESTNET,
    EVM_CHAIN_ID.DODOCHAIN_TESTNET,
    EVM_CHAIN_ID.DUCKCHAIN_TESTNET,
];
/**
 * UNIVERSAL 购买 nft 合约地址
 */
export const NFT_CONTRACT_ADDRESS = {
    [TaikoHekla.id]: '0xdE5ef7a62d1B11D7FA224a2535c9bE2aF61c493d',
    [KakarotSepolia.id]: '0xA630Bbb54085B4CD9280692DFa5fA64c9392Fa29',
    [ZircuitTestnet.id]: '0xa0eB2ec6205c14E2CFC1D2CfcC441b4E065fC1d1',
    [BaseSepolia.id]: '0xAFFbb152384104323650E16c476f6b22BFC825Ed',
    [LineaSepolia.id]: '0xF50C3aeb06f3bDa82f9388CBb9D65cd47fB0c805',
};
//# sourceMappingURL=config.js.map